import styled from 'styled-components'

export const ModalMessages = styled.div`
  .message-sent {
    background-color: #eef8f1 !important;
  }

  .message-received {
    background-color: #f4f6fb !important;
  }
`

export const ChatBody = styled.div`
  height: 50vh;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export const ChatList = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 10px;
`
